import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { Flex, Heading, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react'
import {
  FormSection,
  FormSectionBody,
  FormSectionHeader,
  FormSectionTitle,
} from '../../components/FormSection'
import React from 'react'
import { useGetCompanyDiscount } from '../../model/api/company/useGetCompanyDiscount'
import { ICompanyDiscount, ICompanyDiscounts } from '../../model/interfaces/entities/ICompanyDiscounts'

export const DiscountOverviewPage = () => {
  const { data: insurancesData } = useGetCompanyDiscount({});
  const insurances = insurancesData?.data || []

  const thSx = {borderBottom: '1px solid var(--ok-colors-gray-200)'};

  const getDiscounts = (insurance: ICompanyDiscounts): ICompanyDiscount[] => {
    return [insurance.discount];
  }

  return (
    <Section>
      <Container>
        <PageContent>
          <PageToolbar
            leftElements={
              <Flex sx={{ gap: 4, alignItems: 'center' }}>
                <Heading as="h1">Přehled slev</Heading>
              </Flex>
            }
            rightElements={''}
          />

          <FormSection>
            <FormSectionHeader>
              <FormSectionTitle>
                Pojištění majetku a odpovědnosti
              </FormSectionTitle>
            </FormSectionHeader>

            <FormSectionBody sx={{ w: '100%' }}>
              <Table variant={'striped'} boxShadow={'none'}>
                <Thead sx={thSx}>
                  <Th>Pojišťovna</Th>
                  <Th textAlign={'end'}>Sleva</Th>
                  <Th textAlign={'end'}>Min</Th>
                  <Th textAlign={'end'}>Max</Th>
                  <Th>Kód</Th>
                </Thead>
                <Tbody>
                  {insurances.map(insurance => (
                    getDiscounts(insurance).map((discount, discountKey) => (
                      <Tr sx={discountKey === (getDiscounts(insurance).length - 1) ? thSx : {}}>
                        {discountKey === 0 && (
                          <Th rowSpan={getDiscounts(insurance).length}>{insurance.name}</Th>
                        )}
                        <Td textAlign={'end'}>{discount.name ?? ''}</Td>
                        <Td textAlign={'end'}>{discount.minDiscount ?? '0'} %</Td>
                        <Td textAlign={'end'}>{discount.maxDiscount ?? '0'} %</Td>
                        <Td>{discount.code ?? ''}</Td>
                      </Tr>
                    ))
                  ))}
                </Tbody>
              </Table>
            </FormSectionBody>
          </FormSection>
        </PageContent>
      </Container>
    </Section>
  )
}
